import React from "react";

function DynamicHeader({ firstCat, lastCat }) {
  return (
    <a
      href={`https://tyacfemb.mi-content.com/p/cp/8e4a4558f76b9e3e/c?mi_cat=${firstCat}&mi_subcat=${lastCat}&url=https%3A%2F%2Ftyacfemb.mi-content.com%2Fp%2Frp%2Faf260d2df52844a7%2Furl`}
      style={{ display: "block" }}
    >
      <img
        alt="Display images to show real-time content"
        style={{ border: 0, display: "block" }}
        src={`https://tyacfemb.mi-content.com/p/rp/af260d2df52844a7.png?mi_cat=${firstCat}&mi_subcat=${lastCat}`}
      />
    </a>
  );
}

export default DynamicHeader;
